import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs, Typography, Tooltip, Fab } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import Layout from '@components/Layout';
import UserTable from '@components/user/UserTable';

function UserListPage() {
    const { t } = useTranslation();
    return (
        <Layout withFloatingButton={true}>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
                <Typography>{t('User management')}</Typography>
            </Breadcrumbs>
            <UserTable />
            <RouterLink to="/users/create">
                <Tooltip title={t('Create user')} placement="top" arrow>
                    <Fab color="primary" aria-label={t('Create user')}
                        className="main-fab" sx={{ boxShadow: 6 }}>
                        <AddIcon />
                    </Fab>
                </Tooltip>
            </RouterLink>
        </Layout>
    );
}

export default UserListPage;
